import React from "react";
import RichHtmlWrapper from "components/RichHTMLWrapper/RichHTMLWrapper";

const PrivacyPolicy = React.memo(() => {
  return <RichHtmlWrapper id="Privacy.Content" />;
});

export default PrivacyPolicy;
